import React from 'react';

import { Grid, Paper } from '@material-ui/core';

import { RadioGroupGeneric } from '../molecules/RadioGroupGeneric';
import ToolbarXLSPDF from '../../compartidos/ToolbarXLSPDF';

export const GenericBandeja = ({
  radioList = [],
  radioValue,
  setRadioValue,
  children,
  SearchComponent = [],
  files
}) => {
  const SearchComponents = [
    ...SearchComponent,
    {
      gridProps: {
        xs: 12,
        ...(files ? {md: 10} : {}),
        style: { padding: '0.5em', border: files ? '' : '1px solid #ddd' },
      },
      Component: () => (
        <RadioGroupGeneric
          radioList={radioList}
          onChange={setRadioValue}
          actualValue={radioValue}
        />
      ),
    },
    ...(files ? [{
      gridProps: {
        xs: 12,
        style: { display: "flex", justifyContent: "center" },
        ...(files ? {md: 2} : {})
      },
      Component: () => (
        <ToolbarXLSPDF
          handlePrint={() => { if(files.handlePrint) files.handlePrint() }}
          handleExportExcel={() => { if(files.handleExcel) files.handleExcel() }}
          handleGeneratePdf={() => { if(files.handlePdf) files.handlePdf() }}
          disabledPrint={!files.handlePrint}
          disabledExcel={!files.handleExcel}
          disabledPdf={!files.handlePdf}
        />
      ),
    }] : [])
  ];

  return (
    <Grid spacing={2} container justify='center'>
      <Grid
        item
        xs={12}
        component={Paper}
        elevation={1}
        style={{ padding: 0 }}
      >
        <Grid container alignItems='center'>
          {SearchComponents.map(({ gridProps, Component }, index) => (
            <Grid key={index} item xs={gridProps?.xs || 12} {...gridProps}>
              <Component />
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        component={Paper}
        elevation={1}
        style={{ marginTop: '1.5em', padding: 0 }}
      >
        {children}
      </Grid>
    </Grid>
  );
};

